import React from "react";

const TextInputFloat = ({
  id,
  type = "text",
  label,
  placeholder,
  value,
  setValue,
  error = null,
  Icon = null,
}) => {
  return (
    <div className="w-full">
      <div className="relative w-full p-[2px] focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#FFD700] rounded-xl
  focus-within:bg-gradient-to-r from-[#228B22] to-emerald-600">
        <input
          type={type}
          required
          value={value}
          onChange={(e) => setValue(e.target.value)}
          id={`floating_outlined${id}`}
          className={`block shadow-sm py-3 ${Icon ? "pl-10" : "pl-4"
          } pr-4 w-full text-sm text-gray-900 bg-white
               rounded-lg border-2 border-[#228B22]/20 appearance-none
               focus:border-[#228B22] focus:outline-none focus:ring-0 peer`}
        placeholder={placeholder}
      />
      <label
        htmlFor={`floating_outlined${id}`}
        className={`absolute ${Icon ? "pl-10" : "pl-4"
          } text-sm text-gray-600 font-medium
              transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white
              px-2 peer-focus:px-2 peer-focus:text-[#228B22] peer-placeholder-shown:scale-100
              peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2
              peer-focus:scale-75 peer-focus:-translate-y-4 left-1 rounded`}
      >
        {label}
        </label>
        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#228B22]">
          {Icon}
        </span>
      </div>
      {error && (
        <p
          id="outlined_error_help"
          className="mt-2 text-xs font-semibold text-[#FF4500] bg-red-50 p-2 rounded-lg border border-red-200"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default TextInputFloat;
